module.exports = __webpack_public_path__ + "img/saleItem.16fe91b5.svg";